<template>
    <span v-html="order.paymentStatusLabel" :class="orderPaymentStatusClasses"/>
</template>

<script>
export default {
    name: "DistributionOrderPaymentStatus",
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        orderPaymentStatusClasses() {
            const statusColors = {
                waiting: "warning",
                error: "danger",
                accepted: "success",
                refunded: "info",
                none: "default",
            };
            return `badge badge-${statusColors[this.order.status.payment]}`;
        },
    },
};
</script>

<style scoped>

</style>